import React from "react";
import ReactDom from "react-dom";
import * as R from "ramda";
import FloorPlansPage from "./FloorPlansPage.jsx";
import { HashRouter as Router } from "react-router-dom";

export default function renderFloorPlansPage() {
  document.querySelectorAll(".js-floor-plans-mount").forEach(mount => {
    const config = R.compose(
      JSON.parse,
      R.defaultTo("{}"),
    )(mount.getAttribute("data-config"));

    const filterOptions = R.compose(
      R.pathOr({}, ["filters", "options"]),
    )(config);

    // NOTE: removed due to conflicting functionality (see LMCS-93)
    // const searchString = sessionStorage.getItem("searchString")
    // if (!searchString) {
    //   if (window.location.search) {
    //     sessionStorage.setItem("searchString", JSON.stringify(window.location.search))
    //   }
    // }

    ReactDom.render(
      <Router>
        <FloorPlansPage
          filterOptions={filterOptions}
          unitListingTitle={config.unitListingTitle}
          floorPlanListingTitle={config.floorPlanListingTitle}
        />
      </Router>,
      mount,
    );
  });
}
